import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ExpenseClaim } from "../../types/ExpenseClaim";

export const getAwaitingExpenseClaims = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["awaitingExpenseClaims", dossierId],
    queryFn: (): Promise<ExpenseClaim[]> => {
      return fetchWithAuth<ExpenseClaim[]>(
        "getAwaitingExpenseClaims",
        dossierId
      );
    },
    refetchInterval: options.refetchInterval,
    enabled: isQueryEnabled(options),
  });
};
